import axios from "@/utils/axiosHelper";

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios(
    { url: "/snail/fool/index", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 部门信息设置
export const setAccountInfo = (params) => {
  return axios(
    { url: "/snail/fool/account", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 提交日报
export const submitContext = (params) => {
  return axios(
    { url: "/snail/fool/context", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 获取日报列表
export const getList = (params) => {
  return axios(
    { url: "/snail/fool/list", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 日报点赞or取消or读取
export const likeApi = (params) => {
  return axios(
    { url: "/snail/fool/like", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 个人日志记录
export const logList = (params) => {
  return axios(
    { url: "/snail/fool/log/record", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 日志详情
export const logDetail = (params) => {
  return axios(
    { url: "/snail/fool/details", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 日报留言
export const leaveWord = (params) => {
  return axios(
    { url: "/snail/fool/message", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 留言列表
export const messageList = (params) => {
  return axios(
    { url: "/snail/fool/message/list", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 我的奖励红点
export const awardRed = (params) => {
  return axios(
    { url: "/snail/fool/red", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 中奖信息填写
export const addressApi = (params) => {
  return axios(
    { url: "/snail/fool/address", method: "POST", params },
    { interceptResultCode: false }
  );
};

// AI分析（先拿六维图）
export const analysisAI = (params) => {
  return axios(
    { url: "/snail/fool/log/analysis", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 结果分析（拿后续结果）
export const evaluateAI = (params) => {
  return axios(
    { url: "/snail/fool/log/evaluate", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 登录init数据
export const experienceInit = (params) => {
  return axios(
    { url: "/snail/fool/experience", method: "GET", params },
    { interceptResultCode: false }
  );
};



// WEBPACK FOOTER //
// ./src/pages/snail/aprilfoolsday/api.js